import dynamic from 'next/dynamic';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useIsMount } from '../../hooks/useIsMount';
import { useBuildingsProvider } from '../../context/buildings';
import { declOfNum, JSONToQuery, sleep } from '../../helpers';
import Input from '../Input';
import Checkbox from '../Checkbox';
import Select from '../Select';
import Button from '../Button';
import styles from '../../styles/modules/buildings/BuildingsFilterMobile.module.scss';

const Modal = dynamic(() => import('../Modal'));

const isAnyFilterss = (s) => {
  const arrFilters = [
    'rooms',
    'studio',
    'deadlineQuartal',
    'deadlineYear',
    'priceFrom',
    'priceTo',
    'squareFrom',
    'squareTo',
    'renovation',
    'squareLivingFrom',
    'squareLivingTo',
    'squareKitchenFrom',
    'squareKitchenTo',
    'balcony',
    'ceiling',
    'floorFrom',
    'floorTo',
    'floorsFrom',
    'floorsTo',
    'bathroom',
    'buildingType'
  ];
  let filtersTotal = 0;

  for (let i = 0; i < arrFilters.length; i++) {
    if (s[arrFilters[i]] && (s[arrFilters[i]].length || s[arrFilters[i]] > 0)) filtersTotal++;
  }

  return filtersTotal > 0;
};

const BuildingsFilterMobile = ({ date }) => {
  /** STATES */
  const router = useRouter();
  const isMount = useIsMount();
  const [buildingsState, setBuildingsState] = useBuildingsProvider();
  const [foundCount, setFoundCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [rooms, setRooms] = useState(buildingsState.filter.rooms);
  const [studio, setStudio] = useState(buildingsState.filter.studio);
  const [deadlineQuartal, setDeadlineQuartal] = useState(buildingsState.filter.deadlineQuartal);
  const [deadlineYear, setDeadlineYear] = useState(buildingsState.filter.deadlineQuartal);
  const [squareFrom, setSquareFrom] = useState(buildingsState.filter.squareFrom);
  const [squareTo, setSquareTo] = useState(buildingsState.filter.squareTo);
  const [renovation, setRenovation] = useState(buildingsState.filter.renovation);
  const [priceFrom, setPriceFrom] = useState(buildingsState.filter.priceFrom);
  const [priceTo, setPriceTo] = useState(buildingsState.filter.priceTo);
  const [squareLivingFrom, setSquareLivingFrom] = useState(buildingsState.filter.squareLivingFrom);
  const [squareLivingTo, setSquareLivingTo] = useState(buildingsState.filter.squareLivingTo);
  const [squareKitchenFrom, setSquareKitchenFrom] = useState(
    buildingsState.filter.squareKitchenFrom
  );
  const [squareKitchenTo, setSquareKitchenTo] = useState(buildingsState.filter.squareKitchenTo);
  const [balcony, setBalcony] = useState(buildingsState.filter.balcony);
  const [ceiling, setCeiling] = useState(buildingsState.filter.ceiling);
  const [floorFrom, setFloorFrom] = useState(buildingsState.filter.floorFrom);
  const [floorTo, setFloorTo] = useState(buildingsState.filter.floorTo);
  const [floorsFrom, setFloorsFrom] = useState(buildingsState.filter.floorsFrom);
  const [floorsTo, setFloorsTo] = useState(buildingsState.filter.floorsTo);
  const [bathroom, setBathroom] = useState(buildingsState.filter.bathroom);
  const [buildingType, setBuildingType] = useState(buildingsState.filter.buildingType);

  /** FUNCTIONS */
  const handleSearchClick = () => {
    setBuildingsState({
      type: 'SET_FILTER',
      payload: {
        deadlineQuartal,
        deadlineYear,
        priceFrom,
        priceTo,
        studio,
        rooms,
        squareFrom,
        squareTo,
        squareLivingFrom,
        squareLivingTo,
        squareKitchenFrom,
        squareKitchenTo,
        floorFrom,
        floorTo,
        floorsFrom,
        floorsTo,
        ceiling,
        balcony,
        renovation,
        bathroom,
        buildingType
      }
    });
    setBuildingsState({
      type: 'SET_STATE',
      payload: { ...buildingsState.state, isAnyFilterssMobileVisible: false }
    });
  };
  const handleResetClick = () => {
    setDeadlineQuartal('');
    setDeadlineYear('');
    setPriceFrom('');
    setPriceTo('');
    setStudio(0);
    setRooms([]);
    setSquareFrom('');
    setSquareTo('');
    setSquareLivingFrom('');
    setSquareLivingTo('');
    setSquareKitchenFrom('');
    setSquareKitchenTo('');
    setBalcony([]);
    setCeiling('');
    setFloorFrom('');
    setFloorTo('');
    setFloorsFrom('');
    setFloorsTo('');
    setRenovation([]);
    setBuildingType([]);
    setBathroom([]);

    setBuildingsState({ type: 'SET_FILTER', payload: {} });
    setBuildingsState({
      type: 'SET_STATE',
      payload: { ...buildingsState.state, isAnyFilterssMobileVisible: false }
    });
  };
  const getDeadlineOptions = () => {
    const variants = [
      {
        type: 'option',
        text: 'Сдан',
        value: 'сдан'
      }
    ];
    const serverDate = new Date(date);
    const serverDateQuartal = parseInt((serverDate.getMonth() + 1) / 3, 10);

    for (let i = 0; i < 4; i++) {
      const year = serverDate.getFullYear() + i;

      for (let j = i === 0 ? serverDateQuartal + 1 : 1; j <= 4; j++) {
        variants.push({
          type: 'option',
          text: `До ${j} квартала ${year}`,
          value: `${j}.${year}`
        });
      }
    }

    return variants;
  };

  /** HOOKS */
  useEffect(() => {
    if (isMount) return;

    router.replace(
      `/buildings${JSONToQuery(
        { ...buildingsState.filter, ...buildingsState.pagination, ...buildingsState.sorting },
        ['length'],
        buildingsState.sorting.sort === 'price.value'
          ? ['page=1', 'sort=price.value', 'sortDirection=asc']
          : ['page=1']
      )}`
    );
  }, [buildingsState.filter, buildingsState.pagination]);
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async () => {
      setIsLoading(true);
      await sleep(300);

      try {
        const response = await axios.post(
          process.env.NEXT_PUBLIC_API + '/buildings',
          {
            deadlineQuartal,
            deadlineYear,
            priceFrom,
            priceTo,
            studio,
            rooms,
            squareFrom,
            squareTo,
            squareLivingFrom,
            squareLivingTo,
            squareKitchenFrom,
            squareKitchenTo,
            floorFrom,
            floorTo,
            floorsFrom,
            floorsTo,
            ceiling,
            balcony,
            renovation,
            bathroom,
            buildingType,
            stat: 1
          },
          { signal }
        );

        if (!response.data || response.data.status !== 'ok') throw new Error(response.data.text);

        setFoundCount(response.data.data.count);
        setIsLoading(false);
      } catch (error) {}
    };
    fetchData();

    return () => controller.abort();
  }, [
    deadlineQuartal,
    deadlineYear,
    priceFrom,
    priceTo,
    studio,
    rooms,
    squareFrom,
    squareTo,
    squareLivingFrom,
    squareLivingTo,
    squareKitchenFrom,
    squareKitchenTo,
    balcony,
    ceiling,
    floorFrom,
    floorTo,
    floorsFrom,
    floorsTo,
    renovation,
    buildingType,
    bathroom
  ]);

  /** TEMPLATE */
  return (
    <Modal
      title="Фильтры"
      visibility={buildingsState.state.isAnyFilterssMobileVisible}
      onClose={() =>
        setBuildingsState({
          type: 'SET_STATE',
          payload: { ...buildingsState.state, isAnyFilterssMobileVisible: false }
        })
      }
    >
      <Checkbox
        title="Количество комнат"
        checkboxes={[
          { text: 'Студия', value: 'студия' },
          { text: '1К', value: '1' },
          { text: '2К', value: '2' },
          { text: '3К', value: '3' },
          { text: '4К+', value: '4' }
        ]}
        selected={studio ? ['студия', ...rooms] : rooms}
        onChange={(v) => {
          if (v.includes('студия')) setStudio(1);
          else setStudio(0);

          setRooms(v.filter((x) => x !== 'студия'));
        }}
      />
      <Select
        title="Срок сдачи"
        options={getDeadlineOptions()}
        selected={deadlineQuartal && deadlineYear ? [`${deadlineQuartal}.${deadlineYear}`] : []}
        onChange={(v) => {
          setDeadlineQuartal(v[0] ? v[0].split('.')[0] : '');
          setDeadlineYear(v[0] ? v[0].split('.')[1] : '');
        }}
      />
      <Input
        title="Общая площадь"
        inputs={[
          {
            placeholder: 'Площадь от',
            mask: 'number',
            value: squareFrom,
            max: 999999
          },
          {
            placeholder: 'Площадь до',
            mask: 'number',
            value: squareTo,
            max: 999999
          }
        ]}
        suffix="м²"
        onChange={(v) => {
          setSquareFrom(v[0]);
          setSquareTo(v[1]);
        }}
      />
      <Select
        title="Ремонт"
        options={[
          {
            type: 'option',
            text: 'Отделка "под ключ"',
            value: 'Отделка "под ключ"'
          },
          {
            type: 'option',
            text: 'Подготовка под чистовую отделку',
            value: 'Подготовка под чистовую отделку'
          },
          {
            type: 'option',
            text: 'Черновая отделка',
            value: 'Черновая отделка'
          }
        ]}
        selected={renovation}
        multiple
        onChange={(v) => {
          setRenovation(v);
        }}
      />
      <Input
        title="Стоимость"
        inputs={[
          {
            placeholder: 'Цена от',
            mask: 'money',
            value: priceFrom,
            max: 99999999
          },
          {
            placeholder: 'Цена до',
            mask: 'money',
            value: priceTo,
            max: 99999999
          }
        ]}
        suffix="₽"
        onChange={(v) => {
          setPriceFrom(v[0]);
          setPriceTo(v[1]);
        }}
      />
      <div style={{ borderTop: '1px dashed var(--color-neutral-100)', margin: '18px -12px ' }} />
      <Input
        title="Жилая площадь"
        inputs={[
          {
            placeholder: 'Площадь от',
            mask: 'number',
            value: squareLivingFrom,
            max: 999999
          },
          {
            placeholder: 'Площадь до',
            mask: 'number',
            value: squareLivingTo,
            max: 999999
          }
        ]}
        suffix="м²"
        onChange={(v) => {
          setSquareLivingFrom(v[0]);
          setSquareLivingTo(v[1]);
        }}
      />
      <Input
        title="Кухонная площадь"
        inputs={[
          {
            placeholder: 'Площадь от',
            mask: 'number',
            value: squareKitchenFrom,
            max: 999999
          },
          {
            placeholder: 'Площадь до',
            mask: 'number',
            value: squareKitchenTo,
            max: 999999
          }
        ]}
        suffix="м²"
        onChange={(v) => {
          setSquareKitchenFrom(v[0]);
          setSquareKitchenTo(v[1]);
        }}
      />
      <Checkbox
        title="Балкон"
        checkboxes={[
          { text: 'Балкон', value: 'балкон' },
          { text: 'Лоджия', value: 'лоджия' }
        ]}
        selected={balcony}
        onChange={(v) => {
          setBalcony(v);
        }}
      />
      <Checkbox
        title="Высота потолков"
        checkboxes={[
          { text: 'от 2.5м', value: '2.5' },
          { text: 'от 2.7м', value: '2.7' },
          { text: 'от 3м', value: '3' },
          { text: 'от 4м', value: '4' }
        ]}
        single
        selected={ceiling}
        onChange={(v) => {
          setCeiling(v[0]);
        }}
      />
      <Input
        title="Этаж"
        inputs={[
          {
            placeholder: 'Этаж от',
            mask: 'number',
            value: floorFrom,
            max: 99
          },
          {
            placeholder: 'Этаж до',
            mask: 'number',
            value: floorTo,
            max: 99
          }
        ]}
        suffix="эт"
        onChange={(v) => {
          setFloorFrom(v[0]);
          setFloorTo(v[1]);
        }}
      />
      <Input
        title="Этажей"
        inputs={[
          {
            placeholder: 'Этажей от',
            mask: 'number',
            value: floorsFrom,
            max: 999999
          },
          {
            placeholder: 'Этажей до',
            mask: 'number',
            value: floorsTo,
            max: 999999
          }
        ]}
        suffix="эт"
        onChange={(v) => {
          setFloorsFrom(v[0]);
          setFloorsTo(v[1]);
        }}
      />
      <Checkbox
        title="Санузел"
        checkboxes={[
          { text: 'Совмещенный', value: 'совмещенный' },
          { text: 'Раздельный', value: 'раздельный' },
          { text: 'Два и более', value: 'два и более' }
        ]}
        selected={bathroom}
        onChange={(v) => {
          setBathroom(v);
        }}
      />
      <Select
        title="Материал стен дома"
        options={[
          {
            type: 'option',
            text: 'Блочный',
            value: 'блочный'
          },
          {
            type: 'option',
            text: 'Кирпично-монолитный',
            value: 'кирпично-монолитный'
          },
          {
            type: 'option',
            text: 'Кирпично-панельный',
            value: 'кирпично-панельный'
          },
          {
            type: 'option',
            text: 'Кирпичный',
            value: 'кирпичный'
          },
          {
            type: 'option',
            text: 'Крупно-панельный',
            value: 'крупно-панельный'
          },
          {
            type: 'option',
            text: 'Монолитно-каркасный',
            value: 'монолитно-каркасный'
          },
          {
            type: 'option',
            text: 'Монолитный',
            value: 'монолитный'
          },
          {
            type: 'option',
            text: 'Панельный',
            value: 'панельный'
          }
        ]}
        selected={buildingType}
        multiple
        onChange={(v) => {
          setBuildingType(v);
        }}
      />
      <div className={styles.actions}>
        <Button
          color="red"
          fullWidth
          style={{ marginRight: 12 }}
          visibility={isAnyFilterss(buildingsState.filter)}
          onClick={handleResetClick}
        >
          Очистить
        </Button>
        <Button color="green" onClick={handleSearchClick} loading={isLoading} fullWidth>
          {foundCount > 0
            ? `Показать ${foundCount} ${declOfNum(foundCount, ['квартира', 'квартиры', 'квартир'])}`
            : 'Найти'}
        </Button>
      </div>
    </Modal>
  );
};

export default BuildingsFilterMobile;
